


















































































import { Component, Vue } from 'vue-property-decorator'
import paperDialog from './components/PaperDialogDetails.vue'
@Component({
	components: {
		paperDialog
	}
})
export default class SystemSet extends Vue {
	private excelFlag: string = '0'
	private cancelFlag: string = '0'
	private sendCancelFlag: string = '0'
	private companyInfo: any = {}
	private sendInfo: any = {}
	private name: string = ''
	private phone: string = ''
	private carNum: string = ''
	private chinesePatrn: RegExp = /^[\u2E80-\u9FFF]+$/
	private paperDialogTableVisible: boolean = false
	private created () {
		return Promise.all([
			this.getCompany(),
			this.getSend(),
			this.getExcelFlag()
		])
	}
	private getCompany () {
		return (this as any).$fxHttp.requestGet({
			url: '/business/getCompany'
		}).then((res: any) => {
			this.companyInfo = res
		})
	}
	private getSend () {
		return (this as any).$fxHttp.requestPost({
			url: '/business/getSendSysUser'
		}).then((res: any) => {
			this.sendInfo = res
			this.name = this.sendInfo.sender
			this.phone = this.sendInfo.senderPhone
			this.carNum = this.sendInfo.plateNumber
		})
	}
	private getExcelFlag () {
		return (this as any).$fxHttp.requestPost({
			url: '/business/getSysParameter'
		}).then((res: any) => {
			res.sysparameter === 0 ? this.excelFlag = '0' : this.excelFlag = '1'
			res.revoke_order_bill ? this.cancelFlag = '1' : this.cancelFlag = '0'
			res.sendOutRevokeBill ? this.sendCancelFlag = '1' : this.sendCancelFlag = '0'
		})
	}
	private excelChange (params: any) {
		(this as any).$forceUpdate()
	}
	private cancelFlagChange (params: any) {
		(this as any).$forceUpdate()
		if (params === '0') {
			this.sendCancelFlag = '0'
		}
		(this as any).$forceUpdate()
	}
	private sendCancelChange (params: any) {
		(this as any).$forceUpdate()
	}
	private async onSaveClick (params: any) {
		switch (params) {
			case 'companySys':
				await (this as any).checkCompanyData()
				await	(this as any).saveCompany()
				break
			case 'sendSys':
				await (this as any).saveSend()
				break
			case 'setSys':
				await (this as any).saveSys()
				break
			case 'paper':
				await (this as any).paperDialog()
				break
		}
	}
	private checkCompanyData () {
		if (this.companyInfo.name === '') {
			(this as any).$message.error('企业名称不能为空')
			return Promise.reject()
		} else if (!(this.chinesePatrn.test(this.companyInfo.name))) {
			(this as any).$message.error('企业名称只能是汉字')
			return Promise.reject()
		} else if (this.companyInfo.name.length > 30) {
			(this as any).$message.error('企业名称最大长度为30个字符')
			return Promise.reject()
		} else {
			return Promise.resolve()
		}
	}
	private saveCompany () {
		const data = this.companyInfo
		return (this as any).$fxHttp.requestPost({
			url: '/business/updateCompany',
			data
		}).then((res: any) => {
			(this as any).$message.success('保存成功')
		})
	}
	private saveSend () {
		const data = {
			sender: this.name,
			senderPhone: this.phone,
			plateNumber: this.carNum
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/updateSendSysUser',
			data
		}).then((res: any) => {
			(this as any).$message.success('保存成功')
		})
	}
	private saveSys () {
		const data = {
			sysparameter: this.excelFlag,
			revoke_order_bill: this.cancelFlag,
			sendOutRevokeBill: this.sendCancelFlag
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/updateSysParameter',
			data
		}).then((res: any) => {
			res.sysparameter === 0 ? this.excelFlag = '0' : this.excelFlag = '1'
			res.revoke_order_bill ? this.cancelFlag = '1' : this.cancelFlag = '0'
			res.sendOutRevokeBill ? this.sendCancelFlag = '1' : this.sendCancelFlag = '0',
			(this as any).$message.success('保存成功')
		})
	}
	private paperDialog () {
		this.paperDialogTableVisible  = true
	}
}
